<template>
  <section class="app-transporte">
    <v-container fluid>
      <!-- forçar alinhamento das colunas no topo -->
      <v-row align="start" no-gutters>

        <!-- MENU LATERAL -->
        <v-col cols="12" md="3" lg="2" class="menu-col">
          <div class="menu-wrap">
            <MenuCamara />
          </div>
        </v-col>

        <!-- CONTEÚDO -->
        <v-col cols="12" md="9" lg="10" class="content-col">
          <div class="content-wrap">
            <router-view />
          </div>
        </v-col>

      </v-row>
    </v-container>
  </section>
</template>

<script>
import MenuCamara from './components/MenuCamara.vue';

export default {
  name: 'LayoutCamara',
  components: { MenuCamara },
};
</script>

<style scoped>
/* garante que as colunas comecem todas no mesmo topo */
.menu-wrap {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 0; /* remove margem indesejada */
}

/* previne que o menu ou conteúdo empurrem o topo por margens internas */
.menu-wrap .v-card,
.content-wrap .v-card {
  margin-top: 0 !important;
}

/* adiciona um espaçamento interno consistente para o conteúdo */
.content-wrap {
  padding-left: 16px;
  padding-right: 16px;
  /* se quiser que o conteúdo fique um pouco abaixo do topo do toolbar, use padding-top */
  padding-top: 0;
}

/* pequenas correções de responsividade (opcional) */
@media (max-width: 960px) {
  .content-wrap { padding-left: 8px; padding-right: 8px; }
}
</style>
